import { render, staticRenderFns } from "./EmptyGraph.vue?vue&type=template&id=533c6b45&scoped=true&"
import script from "./EmptyGraph.vue?vue&type=script&lang=js&"
export * from "./EmptyGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533c6b45",
  null
  
)

/* custom blocks */
import block0 from "./EmptyGraph.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports